import React from "react";
import Logo from "../../assets/steam_mind_logo.png";
import Button from "../common/Button";
import KidsImage from "../../assets/course-details/kids.png";

const CompetitionAd = () => {
  return (
    <div className="bg-gradient-to-br from-[#923D8C] to-[#FF6636]  pt-[72px] pb-10 flex flex-col justify-center items-center">
      <img src={Logo} alt="logo" className="w-[90px]" />
      <div className="mt-[68px] mb-10">
        <Button
          btnText="Book a Free Demo Lesson"
          btnClassName="text-2xl font-bold text-[#FF6636] bg-white leading-7 py-[17.5px] w-[327px] rounded-full"
        />
      </div>
      <div className="">
        <img
            src={KidsImage}
            alt="kids learning"
            className="max-w-[469px]  drop-shadow-[0_0_25px_rgba(255,255,255,0.6)]"
          />
      </div>
    </div>
  );
};

export default CompetitionAd;
